import script from "./dbActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./dbActivity.vue?vue&type=script&setup=true&lang=js"

import "./dbActivity.vue?vue&type=style&index=0&id=2a1b77cb&lang=scss"

const __exports__ = script;

export default __exports__